export default "__VITE_ASSET__3bed6502__"